/** Canvas editor for the first file selection. Existing uploads use sp_uploaded-image-editor.js. */
const spUploadCropper = (function() {
  let instance;
  function getInstance() {
    if (!instance) instance = createCropper();
    return instance;
  }

  function createCropper() {

  // ==================================================================
  // Konfiguration
  // ==================================================================
  // 👉 Ratio-Steuerung:
  //    - null / 'free' / undefined  => freies Cropping (kein Ratio-Lock)
  //    - Zahl wie 1.5               => 3/2
  //    - String wie '3/2'           => 1.5
  const CROPPING_ASPECT = null; // <-- HIER anpassen (z. B. '3/2' oder 1.5). Null = frei.

  // ===============================================================
  // Hilfsfunktionen
  // ===============================================================
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  function toCanvasXY(canvas, clientX, clientY){
    const rect = canvas.getBoundingClientRect();
    const sx = canvas.width  / rect.width;
    const sy = canvas.height / rect.height;
    return { x: (clientX - rect.left) * sx, y: (clientY - rect.top) * sy };
  }
  function getCanvasScale(canvas){
    const rect = canvas.getBoundingClientRect();
    return { sx: canvas.width / rect.width, sy: canvas.height / rect.height };
  }
  function handleSizeCanvas(){
    const { sx } = getCanvasScale(stage);
    return Math.max(10, Math.round(15 * sx)); // sichtbare Handles ~15 CSS-px
  }
  function handleHitRadiusCanvas(){
    const { sx } = getCanvasScale(stage);
    return Math.max(14, Math.round(24 * sx)); // unsichtbare, größere Hit-Zone
  }
  function parseAspect(v){
    if (v === null || v === undefined) return NaN; // free
    if (v === 'free') return NaN;
    if (typeof v === 'number' && !Number.isNaN(v)) return v;
    if (typeof v === 'string' && !isNaN(+v)) return +v;
    const p = String(v).split('/');
    if (p.length === 1) return Number(v);
    const a = Number(p[0]), b = Number(p[1]);
    return (a && b) ? a / b : NaN;
  }
  async function loadBitmapFromFile(file){
    if('createImageBitmap' in window){
      try{ return await createImageBitmap(file, { imageOrientation: 'from-image' }); }
      catch(e){ /* fallback unten */ }
    }
    return await new Promise((res)=>{
      const img=new Image();
      img.onload=()=>res(img);
      img.src=URL.createObjectURL(file);
    });
  }

  // ===============================================================
  // State
  // ===============================================================
  let uploadForm      = document.querySelector('form.upload_box');
  const dropArea      = uploadForm?.querySelector('.drop-area');
  const fileInput     = uploadForm?.querySelector('#fileInputCrop');
  const stage         = document.getElementById('stage');
  const SERVER        = 'preview.smileposter.de';

  if (!fileInput || !stage) return;

  const cropperModalV2 = document.getElementById('PopupModal__cropper-v2');

  const ctx = stage.getContext('2d');
  const flipBtn = document.getElementById('flipH');
  const uploadBtn = document.getElementById('upload_btn');

  let bmp = null;           // ImageBitmap oder HTMLImageElement
  let imgFlipX = 1;         // 1 oder -1 (Bild ist sonst unbeweglich)
  let rotation = 0;         // in 90°-Schritten (0, 90, 180, 270)

  const minW = 300;
  const minH = 300;

  // Crop-Rect im Canvas-Koordinatensystem
  const crop = { x: 100, y: 80, w: 600, h: 400 };
  let lockedRatio = NaN; // NaN = free

  // Interaktion
  let pointerMode = null;   // 'move-crop' | 'resize-*'
  let lastX=0,lastY=0;

  // ===============================================================
  // Rendering
  // ===============================================================
  function draw(){
    ctx.setTransform(1,0,0,1,0,0);
    ctx.clearRect(0,0,stage.width,stage.height);

    if (bmp){
      const W = bmp.width, H = bmp.height;
      ctx.save();
      ctx.translate(stage.width/2, stage.height/2);
      ctx.rotate(rotation * Math.PI/180);
      ctx.scale(imgFlipX, 1);
      ctx.drawImage(bmp, -W/2, -H/2);
      ctx.restore();
    }

    // Abdunkeln NUR außerhalb des Crop-Fensters
    ctx.save();

    // Pfad: erst ganze Bühne, dann das Crop-Rechteck – Even-Odd macht ein Loch
    ctx.fillStyle = 'rgba(0,0,0,0.5)';
    ctx.beginPath();
    ctx.rect(0, 0, stage.width, stage.height);
    ctx.rect(crop.x, crop.y, crop.w, crop.h);
    ctx.fill('evenodd');              // <- wichtig: Loch im Overlay

    // optional: klarer Rahmen um den Crop-Bereich
    ctx.strokeStyle = 'rgba(255,255,255,0.9)';
    ctx.lineWidth = 2;
    ctx.strokeRect(crop.x, crop.y, crop.w, crop.h);

    ctx.restore();

    // Rahmen + Griffe
    ctx.save();
    ctx.strokeStyle = '#6aa3ff';
    ctx.lineWidth = 2;
    ctx.setLineDash([6,4]);
    ctx.strokeRect(crop.x, crop.y, crop.w, crop.h);
    ctx.setLineDash([]);
    const hs = handleSizeCanvas();
    ctx.fillStyle = '#6aa3ff';
    for(const p of handlePoints()){ ctx.fillRect(p.x-hs/2, p.y-hs/2, hs, hs); }
    ctx.restore();
  }

  // ===============================================================
  // Crop to Canvas (Export)
  // ===============================================================
  function cropToCanvas(exportWidth) {
    if(!bmp) return null;
    const r = lockedRatio; // NaN => free
    const ratio = Number.isNaN(r) ? (crop.w / crop.h || 1) : r;
    const outW = Math.max(64, Math.round(exportWidth));
    const outH = Math.max(1, Math.round(outW / ratio));
    const out = document.createElement('canvas');
    out.width = outW; out.height = outH;
    const octx = out.getContext('2d');

    const theta = rotation * Math.PI/180;
    const cos = Math.cos(theta), sin = Math.sin(theta);
    const W = bmp.width, H = bmp.height;

    function stageToImageCoord(sx, sy) {
      let x = sx - stage.width/2;
      let y = sy - stage.height/2;
      const xr =  cos*x + sin*y;
      const yr = -sin*x + cos*y;
      const xs = xr / imgFlipX;
      const ys = yr;
      return { x: xs + W/2, y: ys + H/2 };
    }

    const corners = [
      stageToImageCoord(crop.x,           crop.y),
      stageToImageCoord(crop.x+crop.w,    crop.y),
      stageToImageCoord(crop.x+crop.w,    crop.y+crop.h),
      stageToImageCoord(crop.x,           crop.y+crop.h)
    ];
    const minX = Math.min(...corners.map(p=>p.x));
    const minY = Math.min(...corners.map(p=>p.y));
    const maxX = Math.max(...corners.map(p=>p.x));
    const maxY = Math.max(...corners.map(p=>p.y));

    const sx = Math.max(0, Math.floor(minX));
    const sy = Math.max(0, Math.floor(minY));
    const sw = Math.min(W - sx, Math.ceil(maxX - sx));
    const sh = Math.min(H - sy, Math.ceil(maxY - sy));
    if(sw<=0||sh<=0) return null;

    octx.imageSmoothingEnabled = true;
    octx.imageSmoothingQuality = 'high';
    octx.drawImage(bmp, sx, sy, sw, sh, 0, 0, outW, outH);
    return out;
  }

  // ===============================================================
  // Interaction Helpers (Crop Handles)
  // ===============================================================
  function handlePoints(){
    const {x,y,w,h} = crop; const cx=x+w/2, cy=y+h/2;
    return [
      {name:'nw',x:x,y:y}, {name:'n',x:cx,y:y}, {name:'ne',x:x+w,y:y},
      {name:'e',x:x+w,y:cy}, {name:'se',x:x+w,y:y+h}, {name:'s',x:cx,y:y+h},
      {name:'sw',x:x,y:y+h}, {name:'w',x:x,y:cy}
    ];
  }
  function hitHandle(mx,my){
    const r = handleHitRadiusCanvas();
    for(const p of handlePoints()){
      if(Math.abs(mx-p.x)<=r && Math.abs(my-p.y)<=r) return p.name;
    }
    return null;
  }
  function hitRect(mx,my, r){ return mx>=r.x && my>=r.y && mx<=r.x+r.w && my<=r.y+r.h; }

  async function loadImage(files) {
    files = files || [];
    const file = files[0] || '';
    if(!file) return;
    cropperModalV2?.show?.();
    bmp = await loadBitmapFromFile(file);
    fitImageToStage();

    // Ratio: frei (NaN) oder aus externer Funktion/Variable
    const extAspect = (typeof getCroppingAspectRatio === 'function') ? getCroppingAspectRatio() : CROPPING_ASPECT;
    lockedRatio = parseAspect(extAspect); // NaN => free
    //console.log('lockedRatio',lockedRatio);

    //lockedRatio = parseAspect(CROPPING_ASPECT); // NaN => free

    //const extAspect = (typeof getCroppingAspectRatio === 'function') ? getCroppingAspectRatio() : parseAspect('1/1');
    //lockedRatio = extAspect > 1 ? parseAspect('3/2') : parseAspect('2/3');
    

    initDefaultCrop();
    draw();
  }

  // ===============================================================
  // Event Handling – Pointer
  // ===============================================================
  stage.addEventListener('mousedown', (e)=>{
    const {x:mx,y:my} = toCanvasXY(stage, e.clientX, e.clientY);
    lastX=mx; lastY=my;
    const h=hitHandle(mx,my);
    if(h){ pointerMode='resize-'+h; }
    else if(hitRect(mx,my,crop)){ pointerMode='move-crop'; }
    else { pointerMode=null; }
  });

  window.addEventListener('mouseup', ()=>{ pointerMode=null; });

  window.addEventListener('mousemove', (e)=>{
    if (!bmp || !cropperModalV2?.hasAttribute('open')) return;
    const {x:mx,y:my} = toCanvasXY(stage, e.clientX, e.clientY);
    if(!pointerMode){
      const h = hitHandle(mx,my);
      let cur = 'default';
      if(h==='n' || h==='s') cur = 'ns-resize';
      else if(h==='e' || h==='w') cur = 'ew-resize';
      else if(h==='ne' || h==='sw') cur = 'nesw-resize';
      else if(h==='nw' || h==='se') cur = 'nwse-resize';
      else if(hitRect(mx,my,crop)) cur = 'move';
      stage.style.cursor = cur;
    }
    if(!pointerMode) return;
    const dx=mx-lastX, dy=my-lastY; lastX=mx; lastY=my;
    if(pointerMode==='move-crop'){ crop.x+=dx; crop.y+=dy; constrainCrop('move'); }
    else if(pointerMode.startsWith('resize-')){ resizeCrop(pointerMode.replace('resize-',''), dx, dy); constrainCrop('resize'); }
    draw();
  });

  // Touch
  stage.addEventListener('touchstart', (e)=>{
    if(e.touches.length===1){
      const p = toCanvasXY(stage, e.touches[0].clientX, e.touches[0].clientY);
      lastX=p.x; lastY=p.y;
      const h = hitHandle(p.x,p.y);
      if(h) pointerMode = 'resize-'+h; else if(hitRect(lastX,lastY,crop)) pointerMode='move-crop';
    }
  }, {passive:true});

  stage.addEventListener('touchmove', (e)=>{
    if(!pointerMode) return;
    const p = toCanvasXY(stage, e.touches[0].clientX, e.touches[0].clientY);
    const dx=p.x-lastX, dy=p.y-lastY; lastX=p.x; lastY=p.y;
    if(pointerMode==='move-crop'){ crop.x+=dx; crop.y+=dy; constrainCrop('move'); }
    else if(pointerMode && pointerMode.startsWith('resize-')){ resizeCrop(pointerMode.replace('resize-',''), dx, dy); constrainCrop('resize'); }
    draw();
  }, {passive:true});

  stage.addEventListener('touchend', ()=>{ pointerMode=null; });



  // Kein Zoom/Pan
  function zoomAt(cx,cy,newScale){ /* deaktiviert */ }

  // ===============================================================
  // Bounds & MinSize – unterscheidet MOVE vs. RESIZE und FREE vs. LOCKED
  // ===============================================================
  function constrainCrop(mode='resize'){
    const r = lockedRatio; // NaN => free

    if (mode === 'move'){
      crop.x = clamp(crop.x, 0, stage.width  - crop.w);
      crop.y = clamp(crop.y, 0, stage.height - crop.h);
      return;
    }

    // RESIZE
    if (Number.isNaN(r)){
      // FREE: Breite & Höhe unabhängig clampen
      if (crop.x < 0) crop.x = 0;
      if (crop.y < 0) crop.y = 0;

      const maxWByStage = stage.width  - crop.x;
      const maxHByStage = stage.height - crop.y;

      crop.w = clamp(crop.w, minW, maxWByStage);
      crop.h = clamp(crop.h, minH, maxHByStage);

      // rechts/unten sichern (Numerik-Guard)
      if (crop.x + crop.w > stage.width)  crop.x = stage.width  - crop.w;
      if (crop.y + crop.h > stage.height) crop.y = stage.height - crop.h;
      return;
    }

    // LOCKED: Breite aus Ratio ableiten (wie bisher)
    const userMinW = Math.max(1, parseInt(minW||'1',10));
    const userMinH = Math.max(1, parseInt(minH||'1',10));

    if (crop.x < 0) crop.x = 0;
    if (crop.y < 0) crop.y = 0;

    const availW = stage.width  - crop.x;
    const availH = stage.height - crop.y;

    const minWByRatio = Math.max(userMinW, Math.ceil(userMinH * r));
    const maxWByStage = Math.min(availW, Math.floor(availH * r));

    crop.w = clamp(crop.w, minWByRatio, maxWByStage);
    crop.h = Math.round(crop.w / r);

    if (crop.x + crop.w > stage.width)  crop.x = stage.width  - crop.w;
    if (crop.y + crop.h > stage.height) crop.y = stage.height - crop.h;
  }

  function resizeCrop(handle, dx, dy){
    const r = lockedRatio; // NaN => free
    const before = {x:crop.x, y:crop.y, w:crop.w, h:crop.h};

    const isN = handle.includes('n');
    const isS = handle.includes('s');
    const isE = handle.includes('e');
    const isW = handle.includes('w');

    let newW = before.w;
    let newH = before.h;

    // Seitengriffe
    if (isE && !isW && !isN && !isS) newW = before.w + dx;
    else if (isW && !isE && !isN && !isS) newW = before.w - dx;
    else if (isN && !isS && !isE && !isW) newH = before.h - dy;
    else if (isS && !isN && !isE && !isW) newH = before.h + dy;
    else {
      // Ecke: dominante Achse
      const dw = (isE? dx : 0) + (isW? -dx : 0);
      const dh = (isS? dy : 0) + (isN? -dy : 0);
      if (Math.abs(dw) >= Math.abs(dh)) newW = before.w + dw; else newH = before.h + dh;
    }

    if (Number.isNaN(r)){
      // FREE: Ratio nicht erzwingen
      newW = Math.max(newW, minW);
      newH = Math.max(newH, minH);

      // Position abhängig vom Griff, Anker stabil halten
      if (isE && !isW && !isN && !isS) {
        crop.x = before.x; crop.w = newW; crop.h = before.h;
      } else if (isW && !isE && !isN && !isS) {
        const right = before.x + before.w;
        crop.w = newW; crop.h = before.h; crop.x = right - crop.w;
      } else if (isN && !isS && !isE && !isW) {
        const bottom = before.y + before.h;
        crop.h = newH; crop.w = before.w; crop.y = bottom - crop.h;
      } else if (isS && !isN && !isE && !isW) {
        crop.y = before.y; crop.h = newH; crop.w = before.w;
      } else {
        // Ecke: beide Richtungen
        const right = before.x + before.w;
        const bottom = before.y + before.h;
        crop.w = newW; crop.h = newH;
        crop.x = isW ? (right - crop.w) : before.x;
        crop.y = isN ? (bottom - crop.h) : before.y;
      }
      return; // constrainCrop('resize') wird vom Caller aufgerufen
    }

    // LOCKED: Ratio w/h halten
    if (newW !== before.w) newH = newW / r; else newW = newH * r;

    if (newW < minW) { newW = minW; newH = newW / r; }
    if (newH < minH) { newH = minH; newW = newH * r; }

    const center = {x: before.x + before.w/2, y: before.y + before.h/2};
    if (isE && !isW && !isN && !isS) {
      crop.x = before.x; crop.w = newW; crop.h = newH; crop.y = center.y - crop.h/2;
    } else if (isW && !isE && !isN && !isS) {
      const right = before.x + before.w;
      crop.w = newW; crop.h = newH; crop.x = right - crop.w; crop.y = center.y - crop.h/2;
    } else if (isN && !isS && !isE && !isW) {
      const bottom = before.y + before.h;
      crop.h = newH; crop.w = newW; crop.y = bottom - crop.h; crop.x = center.x - crop.w/2;
    } else if (isS && !isN && !isE && !isW) {
      crop.y = before.y; crop.h = newH; crop.w = newW; crop.x = center.x - crop.w/2;
    } else {
      const anchorX = before.x + (isW ? before.w : 0);
      const anchorY = before.y + (isN ? before.h : 0);
      crop.w = newW; crop.h = newH;
      crop.x = isW ? (anchorX - crop.w) : anchorX;
      crop.y = isN ? (anchorY - crop.h) : anchorY;
    }
  }

  function fitImageToStage(){
    if(!bmp) return;
    const rotated = (rotation % 180) !== 0;
    stage.width  = rotated ? bmp.height : bmp.width;
    stage.height = rotated ? bmp.width  : bmp.height;
  }

  function initDefaultCrop(){
    if (Number.isNaN(lockedRatio)){
      // FREE: starte mit vollem Bild (oder leichtem Rand)
      crop.w = stage.width;
      crop.h = stage.height;
    } else {
      // LOCKED: breite = stage.width, höhe aus Ratio
      //const padding = 
      const w = stage.width * 0.9;
      const h = Math.min(stage.height, Math.round(w / lockedRatio));
      crop.w = w;
      crop.h = h;
    }
    constrainCrop('resize');
    crop.x = Math.round((stage.width  - crop.w) / 2);
    crop.y = Math.round((stage.height - crop.h) / 2);
  }

  function setModalBusy(modalEl, busy) {
    const overlay = modalEl.querySelector('.modal-busy-overlay');
    if (!overlay) return;
    overlay.classList.toggle('is-active', busy);
    overlay.setAttribute('aria-hidden', busy ? 'false' : 'true');
    // optional: Accessibility
    modalEl.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  // ===============================================================
  // Controls
  // ===============================================================
  if (flipBtn) {
    flipBtn.addEventListener('click', ()=>{ if(!bmp) return; imgFlipX *= -1; draw(); });
  }

  uploadBtn?.addEventListener('click', async ()=>{
    const outW = crop.w;
    const out = cropToCanvas(outW);
    if(!out) return;
    //cropperModalV2?.hide?.();
    setModalBusy(cropperModalV2,true);
    out.toBlob(async (blob)=>{
      // uploadFormData is initiated in sp_customizer.js
      uploadFormData = new FormData();
      uploadFormData.append('image',blob,'crop.jpg');
      var event = new Event('submit',{ cancelable: true });
      uploadForm.dispatchEvent(event);
      setModalBusy(cropperModalV2,false);
      cropperModalV2?.hide?.();
    }, 'image/png');
  });

  return { loadImage };
  }

  // Register the picker synchronously; its first change is handled directly.
  const uploadForm = document.querySelector('form.upload_box');
  const fileInput = uploadForm?.querySelector('#fileInputCrop');
  const dropArea = uploadForm?.querySelector('.drop-area');
  function openFiles(files) {
    if (files?.length) return getInstance()?.loadImage(files);
  }
  fileInput?.addEventListener('change', event => openFiles(event.target.files));
  fileInput?.addEventListener('click', () => { fileInput.value = null; });
  dropArea?.addEventListener('drop', event => openFiles(event.dataTransfer.files));
})();